import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
const Conditional = (props) => {
    if (!props.visible)
        return null;
    return _jsx(_Fragment, { children: props.children });
};
export default Conditional;
